module.exports = __webpack_public_path__ + "assets/img/NBbag.95e72879.png";